


































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Route } from "vue-router";
// components
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import FixedHtmlForm from "@/components/posts/fixedHtml/FixedHtmlForm.vue";
import vSelect from "vue-select";
import FileSelectModal from "../files/modals/FileSelectModal.vue";
import DirectFileUpload from "../common/files/DirectFileUpload.vue";
import SelectStockImageModal from "@/components/files/modals/SelectStockImageModal.vue";
// types
import { Content, ContentTemplate } from "@/services/contentTemplates/types";
import { contentTemplateValidators } from "@/components/contentTemplates/validators";
import { Style } from "@/services/styles/types";
import { MediaType } from "@/services/files/types";
import { FolderEntites } from "@/services/folders/types";
import { TagTypeEnum, Tag } from "@/services/tags/types";
import { PostTypeEnum } from "@/services/posts/types";
// service methods
import {
    createContentTemplate,
    getContentTemplate,
    updateContentTemplate
} from "@/services/contentTemplates/contentTemplateService";
import { getStyleByType } from "@/services/styles/stylesService";
import { validateForm } from "@/services/validation/validationService";
import { getTags } from "@/services/tags/tagsService";

import i18n from "@/i18n";
import { bus } from "@/bus";
import validate from "@/directives/validate";

@Component<FixedHtmlTemplateForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        HeaderActionButtons,
        UnsavedFormModal,
        FixedHtmlForm,
        FileSelectModal,
        DirectFileUpload,
        vSelect,
        SelectStockImageModal
    },
    directives: {
        validate
    }
})
export default class FixedHtmlTemplateForm extends Vue {
    @Prop() contentTemplateId!: string;
    @Getter("getAllowStockImages") allowStockImages!: boolean;

    // local state
    styles = [] as Array<Style>;
    style = null as Style | any;
    editorReload = 0;
    validators = contentTemplateValidators;
    i18n = i18n;
    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    templateSourceCode = "";
    type = MediaType.Image;
    folders = FolderEntites
    fixedHtmlTags = [] as Array<Tag>;
    addTagMode = false;

    contentTemplate = {
        id: "",
        name: "",
        description: "",
        width: 0,
        height: 0,
        order: 0,
        type: "fixedhtml",
        tags: [] as Tag[],
        content: {
            html: ""
        } as Content
    } as ContentTemplate;

    // used for comparing if form have changes
    priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate)) as ContentTemplate;

    // lifecycle hooks
    async created() {
        this.fetchData();
    }

    // computed
    get editMode() {
        return !!this.contentTemplateId;
    }

    get availableTags() : Tag[] {
        return this.fixedHtmlTags.filter((el) => !this.contentTemplate.tags.some(x => x.id === el.id));
    }

    // router events
    async onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorContentTemplateState, this.contentTemplate) && this.lodash.isEqual(this.priorContentTemplateState.content.html, this.templateSourceCode);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    // methods
    addTag() {
        this.addTagMode = true;
        this.$nextTick(() => {
            // @ts-ignore
            this.$refs.selectTag.$el.querySelector("input[type=search]").focus();
        });
    }

    removeTag(name: string) {
        this.contentTemplate.tags = this.contentTemplate.tags.filter((el) => el.name !== name);
    }

    tagInput(obj: Tag[]) {
        if (obj.length > 0) {
            // check if "id" property exists in the selected object
            // if exists an existing tag is selected, if not than we are dealing with new tag
            if (Object.prototype.hasOwnProperty.call(obj[0], "id")) {
                this.contentTemplate.tags.push(obj[0]);
                this.addTagMode = false;
            } else {
                const tagName = obj[0].toString().trim();

                // if a tag with the same value is already added, do nothing
                if (this.contentTemplate.tags.find(x => x.name.toLowerCase() === tagName.toLowerCase()) || tagName === "") {
                    return;
                }

                // check if the new tag that is added already exists
                const existingTag = this.fixedHtmlTags.find(x => x.name.toLowerCase() === tagName.toLowerCase());
                if (existingTag) {
                    this.contentTemplate.tags.push(existingTag);
                } else {
                    this.contentTemplate.tags.push({ name: tagName } as Tag);
                }

                this.$nextTick(() => {
                    this.addTag();
                });
            }
        }
    }

    // allowed special chars
    // we must use manual check for this chars because when added to the regex expression every special char is allowed
    inputString = "ÆØÅæøåÅÄÖåäö";
    charArray = Array.from(this.inputString);

    isAlphaNumeric(e: any) {
        const char = String.fromCharCode(e.keyCode); // Get the character
        if (/^[[a-zA-Z0-9 -]+$/i.test(char) || this.charArray.includes(char)) return true; // Match with regex
        else e.preventDefault(); // If not match, don't add to input text
    }

    validatePastedTag(e: any) {
        const data = (e.clipboardData.getData("text") || "") as string;
        const containsValidChars = Array.from(data).every(char => {
            return /^[[a-zA-Z0-9 -]+$/i.test(char) || this.charArray.includes(char);
        });

        if (!containsValidChars) {
            e.preventDefault(); // Prevent pasting if not containing valid characters
        }
    }

    fetchData() {
        if (this.contentTemplateId) {
            this.fetchingActive = true;
            getContentTemplate(this.contentTemplateId).then(response => {
                this.contentTemplate = response;
                this.priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate));
                this.templateSourceCode = this.contentTemplate.content.html;
                bus.$emit("documentTitle", this.contentTemplate.name);
                this.fetchingActive = false;
            });
        }

        getTags(TagTypeEnum.FixedHtmlContentTemplate).then(response => {
            this.fixedHtmlTags = response;
        });

        getStyleByType(PostTypeEnum.fixedhtml).then(response => { this.styles = response; });
    }

    async save(back: boolean) {
        if (this.saveClicked) return;
        this.saveClicked = true;
        this.contentTemplate.content.html = this.templateSourceCode;
        if (!await validateForm([this.validators])) {
            this.saveClicked = false;
            return;
        }

        // create or update
        if (this.editMode) {
            updateContentTemplate(this.contentTemplate).then(() => {
                this.saveClicked = false;
                this.priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate));
                if (back) {
                    this.$router.push({
                        name: "contentTemplates",
                        params: { templateType: "fixedHtml" }
                    });
                }
            });
        } else {
            createContentTemplate(this.contentTemplate).then((id: string) => {
                this.saveClicked = false;
                this.contentTemplate.id = id;
                this.contentTemplateId = id;
                this.priorContentTemplateState = JSON.parse(JSON.stringify(this.contentTemplate));

                if (back) {
                    this.$router.push({
                        name: "contentTemplates",
                        params: { templateType: "fixedHtml" }
                    });
                }
            });
        }
    }

    back() {
        this.$router.push({
            name: "contentTemplates",
            params: { templateType: "fixedHtml" }
        });
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    reloadPreview() {
        this.editorReload++;
    }

    resetInputFields() {
        const previewFixedHtml = this.$refs.fixedHtmlPreview as any;
        previewFixedHtml.clearDataOnPreview();
        this.reloadPreview();
    }

    openImageSelectionModal() {
        (this.$refs.SourcefileSelectModal as any).open();
    }

    openDirectUploadImage() {
        (this.$refs.SourceDirectUploadtModal as any).openFileUpload();
    }

    openStockImageModal() {
        if (this.allowStockImages) {
            (this.$refs.selectStockImageModal as any).open();
        }
    }

    insertImage(file: any) {
        const fileId = file.fileId;
        const src = `src="/files/${fileId}"`;

        const textarea = this.$refs.htmlEditor as HTMLTextAreaElement;

        // Get the current cursor position or selection range
        const selectionStart = textarea.selectionStart;
        const selectionEnd = textarea.selectionEnd;

        const currentValue = this.templateSourceCode;

        const updatedValue =
            currentValue.slice(0, selectionStart) +
            src +
            currentValue.slice(selectionEnd);

        this.templateSourceCode = updatedValue;

        textarea.focus();

        // force reload to fix issues when inserting an image INSIDE an element with custom tags (data-vs-XX)
        this.reloadPreview();

        this.$bvModal.hide("SourceFileSelect");
    }
}
